/** 首页路由 */
export default[
    {
        path:'order',
        meta: {title: '订单'},
        name:'index',
        component: ()=>import('@/pages/order/index.vue')
    }
]
